import { Stack } from "@mui/material";
import {
    QueryObserverResult,
    RefetchOptions,
    RefetchQueryFilters,
} from "@tanstack/react-query";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { Loading } from "../../../../../../components/molecules/modals/modal-document/styled-modal-document";
import { useReadBudgetLevel } from "../../../../../../hooks/react-query/use-read-budget-level";
import { TReadBudgetsResponse } from "../../../../../../services/budget/read-budgets";
import RequirimentsContent from "./requiriments-content";

export type TModulesProps = {
    name: string;
    color: string;
    requiriments?: string;
}[];

const ScopeTab = ({
    dataBudgetById,
    refetch,
    isLoading,
}: {
    dataBudgetById?: TReadBudgetsResponse;
    isLoading: boolean;
    refetch: <TPageData>(
        options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
    ) => Promise<QueryObserverResult<TReadBudgetsResponse, unknown>>;
}) => {
    const { budgetId } = useParams();

    const id = budgetId || "";

    const { mutate } = useReadBudgetLevel({
        budgetId: id,
    });

    const levelConfig = dataBudgetById?.LevelConfig ?? [];

    useEffect(() => {
        mutate();
    }, [id]);

    return (
        <Stack
            sx={{
                gap: "1.5rem",
            }}
        >
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <RequirimentsContent
                        levelConfig={levelConfig}
                        budgetId={id}
                        refetch={refetch}
                        dataBudgetById={dataBudgetById}
                    />
                </>
            )}
        </Stack>
    );
};

export default ScopeTab;
